"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSdkConfig = void 0;
/**
 * Configuration of an instance of the platform SDK.
 */
class SdPlatformSdkConfig {
    constructor(
    /** Client id to use */
    clientId, 
    /** Client secret to use */
    clientSecret, 
    /** Base URL of the ShapeDiver Platform Backend */
    baseUrl) {
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.baseUrl = baseUrl;
    }
}
exports.SdPlatformSdkConfig = SdPlatformSdkConfig;
//# sourceMappingURL=SdPlatformSdkConfig.js.map